module.exports = __webpack_public_path__ + "img/people-2.04de608c.png";